import { PriceLineRenderer } from "../canvas/PriceLineRenderer";
/**
 * W0 Task 0.3: side of the slot carrying the price series (default
 * "right"). The last-value badge anchors to the gutter on this side.
 */
export function resolvePriceSlotSide(pane, isPriceSeries) {
    const priceSeries = pane.series.find((s) => isPriceSeries(s) || s.id === "price" || s.id === "candles");
    const slotId = priceSeries?.scaleSlotId ?? "price-right";
    return pane.scaleSlots.find((slot) => slot.id === slotId)?.side ?? "right";
}
function toNumber(value) {
    return typeof value === "number" ? value : Number(value);
}
export class PriceLineOverlay {
    renderer;
    constructor(renderer = new PriceLineRenderer()) {
        this.renderer = renderer;
    }
    render(ctx, options) {
        const priceSeries = options.series.find(options.findPriceSeries);
        if (!priceSeries || options.bars.length === 0) {
            return;
        }
        const slotDomain = options.slotDomains.get(priceSeries.scaleSlotId);
        if (!slotDomain) {
            return;
        }
        const yScale = options.yScaleFor(priceSeries.scaleSlotId, slotDomain);
        const lastClose = toNumber(options.bars[options.bars.length - 1]?.close);
        if (!Number.isFinite(lastClose)) {
            return;
        }
        const lastOpen = toNumber(options.bars[options.bars.length - 1]?.open);
        const prevBar = options.bars[options.bars.length - 2];
        const prevClose = prevBar ? toNumber(prevBar.close) : undefined;
        const targets = [];
        if (options.lastValue) {
            const isBullish = lastClose >= lastOpen;
            targets.push({
                price: lastClose,
                y: yScale(lastClose),
                isBullish,
                color: isBullish ? options.bullColor : options.bearColor,
            });
        }
        if (options.prevCloseLine && prevClose !== undefined && Number.isFinite(prevClose)) {
            targets.push({
                price: prevClose,
                y: yScale(prevClose),
                isBullish: lastClose >= prevClose,
                color: options.mutedColor,
                lineDash: [2, 2],
            });
        }
        for (const target of targets) {
            const renderOptions = {
                plotBounds: options.plotBounds,
                // W0 Task 0.3: the badge follows the price-slot side; legacy
                // callers (no side passed, right gutter only) render as before.
                badgeAxisBounds: options.priceSlotSide === "left"
                    ? (options.leftAxisBounds ?? options.rightAxisBounds)
                    : options.rightAxisBounds,
                y: target.y,
                price: target.price,
                isBullish: target.isBullish,
                color: target.color,
            };
            if (target.lineDash) {
                renderOptions.lineDash = target.lineDash;
            }
            this.renderer.render(ctx, renderOptions);
        }
    }
}
